import { z } from 'zod'

// GET /admin/tenants/:tenantId/seo/geo — AI visibility / GEO Mentions.
// 200 with enabled:false is the empty state (not an error).

export const zSeoGeoMetric = z
  .object({
    target: z.string(),
    metricKey: z.string(),
    value: z.number(),
    capturedOn: z.string(),
  })
  .passthrough()
export type SeoGeoMetric = z.infer<typeof zSeoGeoMetric>

export const zSeoGeoPlatform = z
  .object({
    platform: z.string(),
    metrics: z.array(zSeoGeoMetric).default([]),
  })
  .passthrough()
export type SeoGeoPlatform = z.infer<typeof zSeoGeoPlatform>

export const zSeoGeoLatest = z
  .object({
    platform: z.string(),
    target: z.string(),
    metricKey: z.string(),
    value: z.number(),
    capturedOn: z.string(),
    extra: z.record(z.unknown()).optional(),
  })
  .passthrough()
export type SeoGeoLatest = z.infer<typeof zSeoGeoLatest>

export const zSeoGeo = z
  .object({
    enabled: z.boolean(),
    message: z.string().optional(),
    platforms: z.array(zSeoGeoPlatform).default([]),
    latest: z.array(zSeoGeoLatest).default([]),
  })
  .passthrough()
export type SeoGeo = z.infer<typeof zSeoGeo>
